module.exports = __webpack_public_path__ + "img/failed.3396a86e.png";